import { Text, Flex, FlexProps } from "@mantine/core"

export interface LabeledValueProps extends FlexProps {
  label: string | React.ReactNode
  description?: string | React.ReactNode
  value: string | React.ReactNode
}

export function LabeledValue({ label, value, description, ...props }: LabeledValueProps) {
  return (
    <Flex w="100%" direction="column" {...props}>
      {typeof label === "string" ? (
        <Text
          size="sm"
          style={{ fontWeight: 400, color: "var(--mantine-color-dimmed)" }}
        >
          {label}
        </Text>
      ) : (
        label
      )}
      {description &&
        (typeof label === "string" ? <Text>{description}</Text> : description)}
      {typeof value === "string" ? <Text>{value}</Text> : value}
    </Flex>
  )
}
